"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _PeopleExpand = _interopRequireDefault(require("@rsuite/icon-font/lib/people/PeopleExpand"));

// Generated by script, don't edit it please.
var PeopleExpand = (0, _createSvgIcon["default"])({
  as: _PeopleExpand["default"],
  ariaLabel: 'people expand',
  category: 'people',
  displayName: 'PeopleExpand'
});
var _default = PeopleExpand;
exports["default"] = _default;
module.exports = exports.default;